import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources from './resources/locales';

i18n.use(initReactI18next).init({
  debug: true,
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: 'common',
  ns: [
    'common',
    'learnMore',
    'mockServices',
    'transactions',
    'transactionsDropzone',
    'learnMoreDropzone',
    'marFiles',
    'analytics',
    'environments',
    'certificates',
    'admin',
    'blueprints',
  ],
  interpolation: {
    escapeValue: false,
  },
  resources,
});

export default i18n;
